import { render, staticRenderFns } from "./chinh-sach-thanh-toan.vue?vue&type=template&id=c7d20e72&scoped=true&"
import script from "./chinh-sach-thanh-toan.vue?vue&type=script&lang=js&"
export * from "./chinh-sach-thanh-toan.vue?vue&type=script&lang=js&"
import style0 from "./chinh-sach-thanh-toan.vue?vue&type=style&index=0&id=c7d20e72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d20e72",
  null
  
)

export default component.exports